import { combineReducers } from 'redux';
import { BillingAction } from '../types';
import { Loadable, Reducer } from '../../../types';
import { Invoice } from '../../../../types/items';

import {
  getInvoicesRequest,
  getInvoicesSuccess,
  getInvoicesFail,
} from '../actions';

type State = Loadable<Invoice[]>;
type ReducerOf<T extends keyof State> = Reducer<State, BillingAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getInvoicesRequest.type:
    case getInvoicesFail.type:
      return null;

    case getInvoicesSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getInvoicesRequest.type:
      return true;

    case getInvoicesSuccess.type:
    case getInvoicesFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case getInvoicesRequest.type:
    case getInvoicesSuccess.type:
      return false;

    case getInvoicesFail.type:
      return true;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
  error,
});
